<template>
<div class="container-fluid">
	<div class="modals" @click="hidPop">
	  <div class="modal-content" @click.stop>
		<span class="close" @click="hidPop">&times;</span>
		<div style="text-align: center;margin-top: 25px;">
			<img src="../assets/contact_me_qr.png" style="width: 170px;height: 170px;" />
		</div>
		<p style="margin-top: 25px;">请扫码添加客服</p>
	  </div>
	</div>
</div>
</template>
<script>
	import "../js/bootstrap.bundle.min.js"
	export default {
			name: 'pop',
			props: {
				msg: String,
				from:String
			},
		data() {
			return {
				
			};
		},
		created() {
			console.log(this.msg,this.from);
		},
		mounted() {
			// 添加键盘事件监听
			document.addEventListener('keydown', this.handleKeydown);
		},
		beforeDestroy() {
			// 移除键盘事件监听
			document.removeEventListener('keydown', this.handleKeydown);
		},
		methods: {
			hidPop(){
				console.log('hidPop方法被调用');
				this.$emit('pop',false);
			},
			handleKeydown(event) {
				// ESC键关闭弹窗
				if (event.key === 'Escape') {
					this.hidPop();
				}
			}
		}
	}
</script>

<style scoped>
.modals {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.modal-content {
  background-color: white;
  padding: 30px;
  border-radius: 10px;
  text-align: center;
  position: relative;
  max-width: 400px;
  width: 90%;
}

.close {
  position: absolute;
  top: 10px;
  right: 15px;
  font-size: 24px;
  cursor: pointer;
  color: #999;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.3s ease;
  z-index: 10;
}

.close:hover {
  color: #333;
  background-color: #f5f5f5;
}
</style>
